// Package imports:
import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
// Component imports:
import Table from 'react-bootstrap/Table';
// Service imports:
import { formatDate, formatNumber } from '../../services/utils';
// Action imports:
import { setSelectedTick } from '../../redux-store/actions/dashboardActions';
// Type imports:
import { RootState } from '../../redux-store/reducers';
import { PublicOrderTickData } from '../../types/api/PublicTypes';
import { WithBook } from '../../types/api/Types';

interface IOwnProps {
    orderEvents: WithBook<PublicOrderTickData>[];
    selectedEventIndex: number;
}
type ReduxProps = ConnectedProps<typeof connector>;
type Props = ReduxProps & IOwnProps;

class OrderEventHistory extends React.Component<Props> {
    getChangeIndicator = (
        current: number | null | undefined,
        previous: number | null | undefined
    ): string => {
        if (current === null || current === undefined || previous === null || previous === undefined) return '';
        if (current > previous) return 'changed-up';
        if (current < previous) return 'changed-down';
        return '';
    };

    displayRows = () => {
        const { orderEvents, selectedEventIndex, setSelectedTick } = this.props;

        if (orderEvents.length === 0) {
            return (
                <tr className='NoClick'>
                    <td className='text-left EmptyTableText' colSpan={8}>No events for this order.</td>
                </tr>
            );
        }

        return orderEvents.map(({ tick, book }, index) => {
            const prevTick = index > 0 ? orderEvents[index - 1].tick : null;
            const priceChangeClass = this.getChangeIndicator(tick.price, prevTick?.price);
            const qtyChangeClass = this.getChangeIndicator(tick.quantity, prevTick?.quantity);
            const isSelected = index === selectedEventIndex;

            return (
                <tr
                    key={`${tick.order_id}-${tick.update_code}-${index}`}
                    className={isSelected ? 'current' : undefined}
                    onClick={() => setSelectedTick(tick)}
                >
                    <td>{formatDate(tick.timestamp, true, true)}</td>
                    <td>
                        <span className={`UpdateCode ${tick.update_code ?? ''}`}>{tick.update_code}</span>
                    </td>
                    <td className={priceChangeClass}>{formatNumber(tick.price)}</td>
                    <td className={qtyChangeClass}>{formatNumber(tick.quantity, 'volume')}</td>
                    <td>{formatNumber(tick.value, 'volume')}</td>
                    <td>{formatNumber(book.bookBidPrice)} / {formatNumber(book.bookBidQuantity, 'volume')}</td>
                    <td>{formatNumber(book.bookAskPrice)} / {formatNumber(book.bookAskQuantity, 'volume')}</td>
                    <td>{tick.member}</td>
                </tr>
            );
        });
    };

    render() {
        return (
            <div id='OrderEventHistory'>
                <h5 className='SectionTitle'>Order Event History</h5>
                <Table className='CompressedTable ClickableRows'>
                    <thead>
                        <tr>
                            <th scope='col'>Timestamp</th>
                            <th scope='col'>Event</th>
                            <th scope='col'>Price</th>
                            <th scope='col'>Quantity</th>
                            <th scope='col'>Value</th>
                            <th scope='col'>Bid (Price / Qty)</th>
                            <th scope='col'>Ask (Price / Qty)</th>
                            <th scope='col'>Member</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.displayRows()}
                    </tbody>
                </Table>
            </div>
        );
    }
}

function mapStateToProps({ dashboardReducer }: RootState) {
    const { selectedTick } = dashboardReducer;
    return { selectedTick };
}

const connector = connect(mapStateToProps, { setSelectedTick });
export default connector(OrderEventHistory);
